import '../../../resources/css/admin_style.css';
import googleImg from '../../../resources/images/provider/google_login_small.png';
import naverImg from '../../../resources/images/provider/naver_login_small.png';
import kakaoImg from '../../../resources/images/provider/kakao_login_small.png';
import appleImg from '../../../resources/images/provider/apple-login.png';
import facebookImg from '../../../resources/images/provider/Facebook_Logo.png';
import spotifyImg from '../../../resources/images/provider/Spotify_Primary_Logo_RGB_Green.png';
import twitterImg from '../../../resources/images/provider/icons8-twitter-x-logo.png';
import {useNavigate} from "react-router-dom";
import styles from './component.module.css';
import EditModal from './modal/EditModal';
import { useEffect, useState, useCallback, useContext } from 'react';
import {AuthContext} from "../../../utils/contextapi/AuthProvider";
import axios from '../../../utils/api/axios';
import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import { ESEY_LOGIN_OAUTH2, IAM_PATH, IAM_SERVER_UNIFIEDPROFILE } from '../../../utils/Config';
import dayjs from 'dayjs';
import TimeAgo from '../../../utils/date/timeUtils';
import { getCookie } from '../../../utils/cookies/cookies';
import { InnocodeBadge, InnocodeChip } from '@intsoft/innocode-core';

const PROVIDERS = [
  {
    name: 'google',
    label: '구글 계정으로 로그인',
    moLabel:'구글 로그인',
    color: '#03C75A',
    logo: googleImg,
  },
  {
    name: 'naver',
    label: '네이버 계정으로 로그인',
    moLabel:'네이버 로그인',
    color: '#03C75A',
    logo: naverImg,
  },
  {
    name: 'kakao',
    label: '카카오 계정으로 로그인',
    moLabel:'카카오 로그인',
    color: '#03C75A',
    logo: kakaoImg,
  },
  {
    name: 'apple',
    label: '애플 계정으로 로그인',
    moLabel:'애플 로그인',
    color: '#03C75A',
    logo: appleImg,
  },
  {
    name: 'facebook',
    label: '페이스북 계정으로 로그인',
    moLabel:'페이스북 로그인',
    color: '#4267B2',
    logo: facebookImg,
  },
  {
    name: 'spotify',
    label: '스포티파이 계정으로 로그인',
    moLabel:'스포티파이 로그인',
    color: '#1DB954',
    logo: spotifyImg,
  },
  {
    name: 'twitter',
    label: '트위터 계정으로 로그인',
    moLabel:'트위터 로그인',
    color: '#1DB954',
    logo: twitterImg,
  },
  
];

/**
 * 간편로그인 연결 계정 판넬
 * @param callback
 * @param delay
 */
function LinkedAccountsPanel(user) {
  const [linkedAcounts, setLinkedAccounts] = useState({});
  const [userData, setUserData] = useState({});
  const userId = getCookie('user_id');
  const movePage = useNavigate();
  const {saveToken, saveAuthenticated, saveTokenExpiresIn, saveRole, doLogout } = useContext(AuthContext);

  const [showModal, setShowModal] = useState(false);
  const [currentPw, setCurrentPw] = useState("");
  const [providerToUnlink, setProviderToUnlink] = useState(null); 

  const [isMobileWindow, setIsMobileWindow] = useState(false);

  useEffect(() => {
      const handleResize = () => {
          setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
      };
      handleResize(); // 초기값
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
  }, []);


  const fetchLinkedAccounts = async () => {

    if (!userId) {
      return ;
    }
    
    try {
      const res = await axios.get(`${IAM_SERVER_UNIFIEDPROFILE}/get/${userId}`);
      const user = res.data.data;
      setUserData(user);
      setLinkedAccounts(user.linkedAcounts || {});
    } catch (e) {
      if(e.response.data.status === 401){
        showDialog(DialogEnum.SUCCESS, "로그아웃", "로그인 정보가 올바르지 않습니다. 다시 로그인 해주세요.");
        saveTokenExpiresIn(null);
        saveToken("");
        saveAuthenticated(false);
        saveRole("");
        movePage('/login');
      }
    }
  };

  useEffect(() => {
    fetchLinkedAccounts();
  }, []);

  // ✅ 중복 방지용 listener 분리
  const handleMessage = useCallback(async (event) => {
    const linkedData = event.data;

    if (linkedData?.type === "social_login") {
      const isExist = await existLinkedAcounts(linkedData.auth_id, linkedData.provider);
      if (isExist) {
        showDialog(DialogEnum.DEFAULT, "연결 실패", `${linkedData.provider} 계정은 이미 연동되어 있습니다.`);
        return;
      }

      await updateLinkedAccount(linkedData);
      await fetchLinkedAccounts();
      showDialog(DialogEnum.SUCCESS, "연결 완료", `${linkedData.provider} 계정이 연결되었습니다.`);
    }
  }, [userData]);

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);

  // ✅ 비밀번호 확인 처리 함수 (EditModal의 onSave에 연결)
  const handlePasswordVerification = async () => {
    const userIdForVerification = getCookie("user_id"); // 확인을 위한 userId 재확보

    try {
      const res = await axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/verify/password`, {
        password: currentPw.currentPw,
        unifiedProfileId: userIdForVerification
      });
      const data = res.data;

      if (data.code === 200 || data.success === true) {
        setShowModal(false); // 비밀번호 확인 모달 닫기
        setCurrentPw("");    // 비밀번호 입력 초기화

        // ✅ 비밀번호 확인 성공 후, 저장된 providerToUnlink를 사용하여 연결 해제 확인 다이얼로그 호출
        if (providerToUnlink) {
          unlinkAccountConfirmation(providerToUnlink); 
        } else {
          // 이 경우는 발생하지 않아야 하지만, 안전을 위해 예외 처리
          showDialog(DialogEnum.DEFAULT, "오류", "연결 해제할 계정 정보가 없습니다.");
        }
      } else {
        showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "현재 비밀번호가 일치하지 않습니다.");
        // 비밀번호 불일치 시 모달은 유지하고 비밀번호만 초기화할지, 모달을 닫을지 결정 (여기서는 모달 유지)
      }
    } catch (err) {
      console.error("비밀번호 확인 중 오류 발생:", err);
      showDialog(DialogEnum.DEFAULT, "오류", "비밀번호 확인 중 서버 오류가 발생했습니다.");
    }
  };


  // ✅ 연결 해제 확인 다이얼로그 및 실제 해제 로직 함수 (비밀번호 확인 후 호출)
  const unlinkAccountConfirmation = async (providerName) => {
    showDialog(DialogEnum.CONFIRM, "연동 해제 확인", `${providerName} 계정 연결을 해제 하시겠습니까?`, async () => {
      try {
        await removeLinkedAccount(providerName); // 실제 API 호출
        await fetchLinkedAccounts(); // 연결 해제 후 최신 정보로 갱신
        showDialog(DialogEnum.SUCCESS, "연결 해제", `${providerName} 계정 연결이 해제되었습니다.`);
      } catch (err) {
        showDialog(DialogEnum.DEFAULT, "해제 실패", err.response?.data?.resultMessage || "오류 발생");
        console.error("Failed to remove linked account:", err);
      }
    }, () => {
        // '취소' 버튼 클릭 시 아무것도 하지 않음 (모달만 닫힘)
    });
  };

  const unlinkAccount = async (provider) => {
    const userId = getCookie("user_id");

    axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/verify/password`, {
      password: currentPw,
      unifiedProfileId: userId
    })
    .then((res) => {
      const data = res.data;

      if (data.code === 200 || data.success === true) {
        showDialog(DialogEnum.CONFIRM, "연동 해제 확인", `${provider} 계정 연결을 해제 하시겠습니까?`, async () => {
          try {
            await removeLinkedAccount(provider);
            await fetchLinkedAccounts(); // ✅ 해제 후 최신 정보로 갱신
            showDialog(DialogEnum.SUCCESS, "연결 해제", `${provider} 계정 연결이 해제되었습니다.`);
          } catch (err) {
            showDialog(DialogEnum.DEFAULT, "해제 실패", err.response?.data?.resultMessage || "오류 발생");
          }
        });
      } else {
        showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "현재 비밀번호가 일치하지 않습니다.");
      }
    })
    .catch((err) => {
      showDialog(DialogEnum.DEFAULT, "오류", "서버 오류가 발생했습니다.");
    });


    // showDialog(DialogEnum.CONFIRM, "연동 해제 확인", `${provider} 계정 연결을 해제 하시겠습니까?`, async () => {
    //   try {
    //     await removeLinkedAccount(provider);
    //     await fetchLinkedAccounts(); // ✅ 해제 후 최신 정보로 갱신
    //     showDialog(DialogEnum.SUCCESS, "연결 해제", `${provider} 계정 연결이 해제되었습니다.`);
    //   } catch (err) {
    //     showDialog(DialogEnum.DEFAULT, "해제 실패", err.response?.data?.resultMessage || "오류 발생");
    //   }
    // });
  };

  const startOAuthPopup = (provider) => {
    let socialUrl;

    if (provider === 'apple') {
        // Apple 인증 페이지 URL 생성
        const appleAuthConfig = {
            client_id: 'kr.intsoft.zentry', // Apple Developer에서 발급받은 Services ID
            redirect_uri: 'https://iam.innocode.co/oauth/apple/callback', // 백엔드의 /oauth/apple/callback 주소
            response_type: 'code', // code를 받기 위함
            scope: 'name email', // 이름과 이메일 요청
            response_mode: 'form_post', // 백엔드 콜백으로 POST 요청을 보내도록 설정
            state: 'STATE_STRING' // CSRF 방지를 위한 임의의 문자열
        };
        const appleAuthQueryString = new URLSearchParams(appleAuthConfig).toString();
        socialUrl = `https://appleid.apple.com/auth/authorize?${appleAuthQueryString}`;
    } else if (provider === 'spotify') {
            const spotifyAuthConfig = {
                client_id: '32b85776edaf48c1be1ed45305218bdc', 
                response_type: 'code',
                redirect_uri: 'https://iam.innocode.co/oauth/spotify/callback', 
                scope: 'user-read-private user-read-email', 
                state: 'STATE_STRING' // CSRF 방지를 위한 임의의 문자열
            };
            const spotifyAuthQueryString = new URLSearchParams(spotifyAuthConfig).toString();
            socialUrl = `https://accounts.spotify.com/authorize?${spotifyAuthQueryString}`;
        }
    else {
        // 기존 Google, Naver, Kakao 처리 방식
        socialUrl = `https://iam.innocode.co/oauth2/authorization/${provider}`;
    }

    const width = 500;
    const height = 600;
    const currentLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const currentTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    const popLeft = currentLeft + (currentWidth / 2) - (width / 2);
    const popTop = currentTop + (currentHeight / 2) - (height / 2);
    const features = `width=${width},height=${height},left=${popLeft},top=${popTop}`;

    window.open(socialUrl, `${provider}_oauth_popup`, features);
  };

  const existLinkedAcounts = async (id, provider) => {
    const requestData = {
      linkedAcounts: {
        [provider]: {
          oauth_id: id,
        },
      },
    };
    const res = await axios.post(`${IAM_PATH}/exist/linkedacounts`, requestData);
    return res.data?.data !== null && res.data?.data !== undefined;
  };

  const updateLinkedAccount = async (linkedData) => {
    const now = new Date().toISOString();
    const currentLinked = userData.linkedAcounts || {};

    if (linkedData.provider === "google" || linkedData.provider === "naver") {
      currentLinked[linkedData.provider] = {
        provider: linkedData.provider,
        oauth_id: linkedData.auth_id,
        email: linkedData.email,
        connected_at: now,
      };
    } else {
      currentLinked[linkedData.provider] = {
        provider: linkedData.provider,
        oauth_id: linkedData.auth_id,
        connected_at: now,
      };
    }

    await axios.post(`${IAM_PATH}/update/linkedacounts`, {
      unifiedProfileId: userId,
      linkedAcounts: currentLinked,
    });
  };

  const removeLinkedAccount = async (provider) => {
    const currentLinked = userData.linkedAcounts || {};
    delete currentLinked[provider];

    await axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/update`, {
      unifiedProfileId: userId,
      linkedAcounts: currentLinked,
    });
  };

  const renderRow = (provider) => {
    const data = linkedAcounts[provider.name];
    const isConnected = !!data;
    const linkedAt = data?.connected_at;

    return (
      <div key={provider.name} className={styles.linkedRow}>
        <img src={provider.logo} alt={provider.name} className={styles.linkedLogo} />
        <span className={styles.linkedLabel}>{ isMobileWindow ? provider.moLabel : provider.label}</span>

        {isConnected ? 
          <span className={styles.linkedDate}>
            {/* {dayjs(linkedAt).format('YYYY-MM-DD HH:mm:ss')}  */}
            <TimeAgo date={linkedAt} />
          </span>
        :
          <span className={styles.linkedDate}>
            미연동
          </span>
        } 
        {/* <span
          className={`${styles.linkedToggle} ${isConnected ? styles.active : styles.inactive}`}
          // style={{ backgroundColor: isConnected ? '#F83A3AFF' : '#26D977FF', cursor: 'pointer' }}
          onClick={() => {
            if (isConnected) {
              // ✅ 연결된 계정인 경우, 연결 해제할 provider를 저장하고 비밀번호 확인 모달 띄우기
              setProviderToUnlink(provider.name); 
              setShowModal(true); 
            } else {
              // 미연결 계정인 경우, OAuth 팝업 시작
              startOAuthPopup(provider.name); 
            }
          }}
        >
          {isConnected ? '해지' : '연동'}
        </span> */}
        <InnocodeBadge
          // backgroundColor={isConnected ? 'var(--status-negative, #f83a3a)' : 'var(--status-positive, #26d977'}
          style={{ cursor: 'pointer', backgroundColor: isConnected ? 'var(--status-negative, #f83a3a)' : 'var(--status-positive, #26d977' }}
          onClick={() => {
            if (isConnected) {
              // ✅ 연결된 계정인 경우, 연결 해제할 provider를 저장하고 비밀번호 확인 모달 띄우기
              setProviderToUnlink(provider.name); 
              setShowModal(true); 
            } else {
              // 미연결 계정인 경우, OAuth 팝업 시작
              startOAuthPopup(provider.name); 
            }
          }}
        >
        {isConnected ? '해지' : '연동'}
        </InnocodeBadge>
      </div>
    );
  };

  return (
    <>

      {showModal && (
        <EditModal
          title="비밀번호 확인"
          type="password_verify"
          value={currentPw}
          onChange={setCurrentPw}
          onClose={()=>{setShowModal(false); setCurrentPw(""); setProviderToUnlink(null);}} 
          onSave={handlePasswordVerification} // ✅ 비밀번호 확인 후 처리할 새로운 함수 연결
        />
      )}

      <div className={styles.infoCard}>
        <h2 className={styles.infoTitle}>연동 계정</h2>
        <div className={styles.linkedList}>
          {PROVIDERS.map(renderRow)}
        </div>
      </div>
    
    </>

  );
}

export default LinkedAccountsPanel;